import { seasonFor, type Season } from '../data/season.ts';
import type { RouteData } from '../sim/types.ts';
import type { DecorationData } from './decoration.ts';
import { halloweenDecor } from './seasons/halloween.ts';

/**
 * Seasonal props along a route: what the season in shared/season.ts puts
 * out, drawn in two layers, one beside the road under the cars and one over
 * them.
 *
 * Each season's props live in a file of their own under seasons/, placed once
 * when the route loads, from the route's own samples and decoration. A new
 * season is a new file there and a line in DRAWERS; the old one can stay for
 * next year.
 *
 * Presentation only, like all decoration: nothing here reaches the sim.
 */
export interface SeasonalDecor {
  /** Beside the road, under the cars. `from`..`to` is the route's samples in view. */
  drawGround(ctx: CanvasRenderingContext2D, from: number, to: number, clock: number, px: number): void;
  /** Over the cars. */
  drawOverhead(ctx: CanvasRenderingContext2D, from: number, to: number, clock: number, px: number): void;
}

const DRAWERS: Record<Season['decor'], (route: RouteData, deco: DecorationData | null) => SeasonalDecor> = {
  halloween: halloweenDecor,
};

/** The props for this route today, or null if the season does not dress it. */
export function seasonalDecor(route: RouteData, deco: DecorationData | null): SeasonalDecor | null {
  const season = seasonFor(route.id);
  return season ? DRAWERS[season.decor](route, deco) : null;
}
